import { render, staticRenderFns } from "./NewsStream.vue?vue&type=template&id=6944b954"
import script from "./NewsStream.vue?vue&type=script&lang=js"
export * from "./NewsStream.vue?vue&type=script&lang=js"
import style0 from "./NewsStream.vue?vue&type=style&index=0&id=6944b954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports